export const spacing = {
  base: 8,
} as const;
